// extracted by mini-css-extract-plugin
export default {"suggest":"suggest_suggest__-uokk","text":"suggest_text__iKNHE","text-mobile":"suggest_text-mobile__2zZsG","icon":"suggest_icon__QCfMz","icon-mobile":"suggest_icon-mobile__n85qT"};